// tslint:disable
/**
 * File manager api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { Disk } from '../models';
import { DiskEdit } from '../models';
import { DiskList } from '../models';
import { DiskPermissionEdit } from '../models';
import { DiskRename } from '../models';
/**
 * DiskApi - axios parameter creator
 * @export
 */
export const DiskApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DiskEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body: DiskEdit, options: any = {}): RequestArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling create.');
            }
            const localVarPath = `/disk`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {Array<string>} [ownerIds] 
         * @param {Array<string>} [usersIds] 
         * @param {Array<string>} [readUsersIds] 
         * @param {Array<string>} [writeUsersIds] 
         * @param {string} [title] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(ids?: Array<string>, ownerIds?: Array<string>, usersIds?: Array<string>, readUsersIds?: Array<string>, writeUsersIds?: Array<string>, title?: string, offset?: number, limit?: number, options: any = {}): RequestArgs {
            const localVarPath = `/disk`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }

            if (ownerIds) {
                localVarQueryParameter['ownerIds'] = ownerIds.join(COLLECTION_FORMATS.csv);
            }

            if (usersIds) {
                localVarQueryParameter['usersIds'] = usersIds.join(COLLECTION_FORMATS.csv);
            }

            if (readUsersIds) {
                localVarQueryParameter['readUsersIds'] = readUsersIds.join(COLLECTION_FORMATS.csv);
            }

            if (writeUsersIds) {
                localVarQueryParameter['writeUsersIds'] = writeUsersIds.join(COLLECTION_FORMATS.csv);
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use \"/disk\" method with query parameter \"userIds\"
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        my(offset: number, limit: number, options: any = {}): RequestArgs {
            // verify required parameter 'offset' is not null or undefined
            if (offset === null || offset === undefined) {
                throw new RequiredError('offset','Required parameter offset was null or undefined when calling my.');
            }
            // verify required parameter 'limit' is not null or undefined
            if (limit === null || limit === undefined) {
                throw new RequiredError('limit','Required parameter limit was null or undefined when calling my.');
            }
            const localVarPath = `/disk/my`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} diskId 
         * @param {DiskRename} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameDisk(diskId: string, body: DiskRename, options: any = {}): RequestArgs {
            // verify required parameter 'diskId' is not null or undefined
            if (diskId === null || diskId === undefined) {
                throw new RequiredError('diskId','Required parameter diskId was null or undefined when calling renameDisk.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling renameDisk.');
            }
            const localVarPath = `/disk/{diskId}/rename`
                .replace(`{${"diskId"}}`, encodeURIComponent(String(diskId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} diskId 
         * @param {DiskEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(diskId: string, body: DiskEdit, options: any = {}): RequestArgs {
            // verify required parameter 'diskId' is not null or undefined
            if (diskId === null || diskId === undefined) {
                throw new RequiredError('diskId','Required parameter diskId was null or undefined when calling update.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling update.');
            }
            const localVarPath = `/disk/{diskId}`
                .replace(`{${"diskId"}}`, encodeURIComponent(String(diskId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} diskId 
         * @param {DiskPermissionEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePermissions(diskId: string, body: DiskPermissionEdit, options: any = {}): RequestArgs {
            // verify required parameter 'diskId' is not null or undefined
            if (diskId === null || diskId === undefined) {
                throw new RequiredError('diskId','Required parameter diskId was null or undefined when calling updatePermissions.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updatePermissions.');
            }
            const localVarPath = `/disk/{diskId}/permissions`
                .replace(`{${"diskId"}}`, encodeURIComponent(String(diskId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DiskApi - functional programming interface
 * @export
 */
export const DiskApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DiskEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body: DiskEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Disk> {
            const localVarAxiosArgs = DiskApiAxiosParamCreator(configuration).create(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {Array<string>} [ownerIds] 
         * @param {Array<string>} [usersIds] 
         * @param {Array<string>} [readUsersIds] 
         * @param {Array<string>} [writeUsersIds] 
         * @param {string} [title] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(ids?: Array<string>, ownerIds?: Array<string>, usersIds?: Array<string>, readUsersIds?: Array<string>, writeUsersIds?: Array<string>, title?: string, offset?: number, limit?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiskList> {
            const localVarAxiosArgs = DiskApiAxiosParamCreator(configuration).list(ids, ownerIds, usersIds, readUsersIds, writeUsersIds, title, offset, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Use \"/disk\" method with query parameter \"userIds\"
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        my(offset: number, limit: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiskList> {
            const localVarAxiosArgs = DiskApiAxiosParamCreator(configuration).my(offset, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} diskId 
         * @param {DiskRename} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameDisk(diskId: string, body: DiskRename, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Disk> {
            const localVarAxiosArgs = DiskApiAxiosParamCreator(configuration).renameDisk(diskId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} diskId 
         * @param {DiskEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(diskId: string, body: DiskEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Disk> {
            const localVarAxiosArgs = DiskApiAxiosParamCreator(configuration).update(diskId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} diskId 
         * @param {DiskPermissionEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePermissions(diskId: string, body: DiskPermissionEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Disk> {
            const localVarAxiosArgs = DiskApiAxiosParamCreator(configuration).updatePermissions(diskId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DiskApi - factory interface
 * @export
 */
export const DiskApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {DiskEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body: DiskEdit, options?: any) {
            return DiskApiFp(configuration).create(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {Array<string>} [ownerIds] 
         * @param {Array<string>} [usersIds] 
         * @param {Array<string>} [readUsersIds] 
         * @param {Array<string>} [writeUsersIds] 
         * @param {string} [title] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(ids?: Array<string>, ownerIds?: Array<string>, usersIds?: Array<string>, readUsersIds?: Array<string>, writeUsersIds?: Array<string>, title?: string, offset?: number, limit?: number, options?: any) {
            return DiskApiFp(configuration).list(ids, ownerIds, usersIds, readUsersIds, writeUsersIds, title, offset, limit, options)(axios, basePath);
        },
        /**
         * Use \"/disk\" method with query parameter \"userIds\"
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        my(offset: number, limit: number, options?: any) {
            return DiskApiFp(configuration).my(offset, limit, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} diskId 
         * @param {DiskRename} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameDisk(diskId: string, body: DiskRename, options?: any) {
            return DiskApiFp(configuration).renameDisk(diskId, body, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} diskId 
         * @param {DiskEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(diskId: string, body: DiskEdit, options?: any) {
            return DiskApiFp(configuration).update(diskId, body, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} diskId 
         * @param {DiskPermissionEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePermissions(diskId: string, body: DiskPermissionEdit, options?: any) {
            return DiskApiFp(configuration).updatePermissions(diskId, body, options)(axios, basePath);
        },
    };
};

/**
 * DiskApi - object-oriented interface
 * @export
 * @class DiskApi
 * @extends {BaseAPI}
 */
export class DiskApi extends BaseAPI {
    /**
     * 
     * @param {DiskEdit} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiskApi
     */
    public create(body: DiskEdit, options?: any) {
        return DiskApiFp(this.configuration).create(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {Array<string>} [ownerIds] 
     * @param {Array<string>} [usersIds] 
     * @param {Array<string>} [readUsersIds] 
     * @param {Array<string>} [writeUsersIds] 
     * @param {string} [title] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiskApi
     */
    public list(ids?: Array<string>, ownerIds?: Array<string>, usersIds?: Array<string>, readUsersIds?: Array<string>, writeUsersIds?: Array<string>, title?: string, offset?: number, limit?: number, options?: any) {
        return DiskApiFp(this.configuration).list(ids, ownerIds, usersIds, readUsersIds, writeUsersIds, title, offset, limit, options)(this.axios, this.basePath);
    }

    /**
     * Use \"/disk\" method with query parameter \"userIds\"
     * @param {number} offset 
     * @param {number} limit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiskApi
     */
    public my(offset: number, limit: number, options?: any) {
        return DiskApiFp(this.configuration).my(offset, limit, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} diskId 
     * @param {DiskRename} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiskApi
     */
    public renameDisk(diskId: string, body: DiskRename, options?: any) {
        return DiskApiFp(this.configuration).renameDisk(diskId, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} diskId 
     * @param {DiskEdit} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiskApi
     */
    public update(diskId: string, body: DiskEdit, options?: any) {
        return DiskApiFp(this.configuration).update(diskId, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} diskId 
     * @param {DiskPermissionEdit} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiskApi
     */
    public updatePermissions(diskId: string, body: DiskPermissionEdit, options?: any) {
        return DiskApiFp(this.configuration).updatePermissions(diskId, body, options)(this.axios, this.basePath);
    }

}
